import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';
import { catalogModule as catalog } from '@/store/resource/catalogModule';
import { specimenModule as specimen } from '@/store/resource/specimenModule';
import { markModule as mark } from '@/store/resource/markModule';
import { specDetailModule as specDetail } from '@/store/resource/specDetailModule';

const URL = {
  VERSION_LIST: '/dh-datamaint/version/listAll',
  SUBMIT_VERSION: '/dh-datamaint/version/submit',
  VERSION_LIST_SELF: '/dh-datamaint/version/listSelf'
};

class ResourceModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getVersionList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_LIST, { params: payload.data });
    },

    async getVersionListSelf(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_LIST_SELF, { params: payload.data });
    },

    async submitVersion(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SUBMIT_VERSION, payload.data);
    }
  };

  modules = {
    catalog,
    specimen,
    mark,
    specDetail
  };
}

export const resourceModule = new ResourceModule();
